angular.module('impactx.login').controller('DemoUserLoginCtrl', [
    'dataGen',
    '$routeParams',
    '$redirect',
    '$securityManager',
    'LoginService',
    '$mdDialog',
    DemoUserLoginController]);

function DemoUserLoginController(dataGen, $routeParams, $redirect, $securityManager, LoginService, $mdDialog) {
    var userId = $routeParams.userId;
    if (userId) {
        dataGen.getData({}, {id: userId}, '/demo/login').then(function (response) {
            if (response.data) {
                $mdDialog.hide();
                LoginService.refreshUI(true);
            }
            else {
                $redirect.redirectTo(null, "login");
            }
        });
    }
    else {
        $redirect.redirectTo(null, "login");
    }
}